import {observer} from "mobx-react-lite";
import React from "react";
import {useTranslation} from "react-i18next";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {EventTemplateStatus} from "../../../shared/enums/eventTemplateStatus";
import {IconSource} from "../../../shared/enums/iconSource";
import {EventTemplateDetail} from "../../../stores/domainStore/pages/models/eventTemplateDetail";
import ButtonIcon from "../../atoms/button/buttonIcon";
import NavigationButton from "../../atoms/button/navigationButton";
import CircleIcon from "../../atoms/circleIcon/circleIcon";
import Tag from "../../atoms/tag/tag";
import "./eventTemplateDetailModal.sass";
import Icon from "../../atoms/common/icon/icon";

export interface IEventTemplateDetailModalProps {
  templateDetail: EventTemplateDetail;
  isLoading: boolean;
  isOpen: boolean;
  onEditTemplate: (eventTemplateId: string) => void;
  onClose: () => void;
}

const EventTemplateDetailModal: React.FC<IEventTemplateDetailModalProps> = ({
  templateDetail,
  isLoading,
  isOpen,
  onEditTemplate,
  onClose
}) => {
  const {t} = useTranslation(["translation", "eventTemplate"]);

  const templateTag = (): React.ReactNode => {
    switch (templateDetail.eventTemplateStatus) {
      case EventTemplateStatus.Active:
        return (
          <Tag type="success" text={t("eventTemplate:labels.published")} />
        );
      case EventTemplateStatus.Archived:
        return <Tag type="neutral" text={t("eventTemplate:labels.archived")} />;
    }
    return <></>;
  };

  return (
    <Modal
      isOpen={isOpen}
      modalClassName="theme-modal template-detail-modal"
      contentClassName="border"
      centered
      data-testid="eventTemplateDetailModal"
    >
      <ModalHeader
        close={<NavigationButton icon={IconSource.exit} onClick={onClose} />}
      >
        <>
          <div>
            <div>
              {templateDetail.isVillageFavourite ? (
                <Icon source={IconSource.favourite} />
              ) : null}
            </div>
            <div>{templateDetail.title}</div>
          </div>
        </>
      </ModalHeader>
      <ModalBody>
        <div>
          <span>{t("eventTemplate:titles.templateDetails")}</span>
          {templateTag()}
        </div>
        <div>
          <div>
            <CircleIcon icon={IconSource.catalogue} />
            <div>{templateDetail.categoryName}</div>
          </div>
          <div>
            <CircleIcon icon={IconSource.recent} />
            <div>{templateDetail.duration}</div>
          </div>
          <div className="line-clamp">
            <CircleIcon icon={IconSource.description} />
            <div>{templateDetail.description}</div>
          </div>
        </div>
      </ModalBody>
      {templateDetail.eventTemplateStatus === EventTemplateStatus.Active && (
        <ModalFooter>
          <ButtonIcon
            type="primary"
            icon={IconSource.edit}
            onClick={() => onEditTemplate(templateDetail.id)}
          >
            {t("translation:actions.edit")}
          </ButtonIcon>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default observer(EventTemplateDetailModal);
